import MediaThumb from "@/Components/Media/MediaThumb";
import type { IMediaThumbProps, IWebCOOSParsedAssetService } from "@/services/assets/types";
import { useLatestServiceMedia } from "@/services/media/useLatestServiceMedia";
import { useAPIContext } from "@/state/ApiContext";
import { ViewWithLoader } from "@axdspub/axiom-ui-utilities";

const LatestImage = ({
    service,
    asset,
    assetLabel,
    className,
    defaultClassName = 'relative w-full h-full',
    imageClassName,
    defaultImageClassName = 'object-cover w-full h-full',
    ...props
}: Omit<IMediaThumbProps, 'element'> & { service: IWebCOOSParsedAssetService }) => {
    const apiContext = useAPIContext()
    const { data, isLoading, error } = useLatestServiceMedia({
        ...apiContext,
        serviceIdentifier: service.uuid
    });

    return <ViewWithLoader isLoading={isLoading} error={error} data={data}>
        {data !== null && data !== undefined ? (
            <MediaThumb
                asset={asset}
                assetLabel={assetLabel ? `Latest image for ${assetLabel}` : 'Latest Image'}
                imageClassName={imageClassName}
                defaultClassName={defaultClassName}
                defaultImageClassName={defaultImageClassName}
                className={className}
                element={data}
                {...props}
            />

        ) : null}
    </ViewWithLoader>



}

export default LatestImage